export default "__VITE_ASSET__CtR0ctuA__"